import { State } from '@/store/state';
import { IUser, User } from '@/models/User';
import constants from '@/utils/constants';

export default {
  TOGGLE_LOADING(state: State): void {
    state.callingAPI = !state.callingAPI;
  },
  START_LOADING(state: State): void {
    state.callingAPI = true;
  },
  STOP_LOADING(state: State): void {
    state.callingAPI = false;
  },
  USER_PAGE_PERMISSION(
    state: State,
    permission: string = constants.PERMISSION_N
  ) {
    state.userPagePermission = permission;
  },
  UPDATE_CURRENT_USER(state: State, user: IUser) {
    state.currentUser = new User(user);
  },
  UPDATE_USER_PRIVILEGES(state: State, isMaster: boolean) {
    state.isMaster = isMaster;
  },
  UPDATE_AUTO_PRINT(state: State, payload) {
    state.autoPrint = payload;
  },
  UPDATE_EDC_MODEL(state: State, payload) {
    state.isEDC = payload;
  }
};
